import {
    ResetButtonContainer as SourceResetButtonContainer,
} from 'SourceComponent/ResetButton/ResetButton.container';

export class ResetButtonContainer extends SourceResetButtonContainer {
    
}

export default ResetButtonContainer;
